import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestMovies from './components/LatestMovies';
import ArticleRecommend from './components/ArticleRecommend';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '免费电影在线观看 - 海量高清免费电影资源',
            description: '汇聚海量高清免费电影资源，涵盖国产、好莱坞、动漫、纪录片等全类型，无需注册、无需付费，随时随地畅享免费电影观看体验。',
            url: 'https://viewhubx.github.io/',
            isPartOf: {
              '@type': 'WebSite',
              name: '免费电影在线观看',
              url: 'https://viewhubx.github.io/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '本站的电影资源真的全部免费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的！本站所有电影资源均免费提供，无需注册、无需付费，用户可随时随地在线观看海量高清电影。',
                },
              },
              {
                '@type': 'Question',
                name: '免费电影网站支持哪些类型的电影？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站涵盖国产电影、好莱坞大片、日韩电影、动作片、喜剧片、科幻片、恐怖片、动漫、纪录片等全类型电影资源，满足各类观众的观影需求。',
                },
              },
              {
                '@type': 'Question',
                name: '免费电影网站的电影画质如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站提供高清免费电影资源，所有影片均经过精心筛选，确保最佳的在线观看体验。',
                },
              },
              {
                '@type': 'Question',
                name: '免费电影网站需要注册账号吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不需要！本站完全免费且无需注册，打开网站即可立即观看海量免费电影资源。',
                },
              },
              {
                '@type': 'Question',
                name: '免费电影网站多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站每日更新最新免费电影资源，确保用户能第一时间观看到最新上线的影片。',
                },
              },
            ],
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <LatestMovies />
          <HotRanking />
          <ArticleRecommend />

          <section className="py-10 md:py-14">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="rounded-xl bg-gradient-to-r from-accent-500/10 via-primary-500/10 to-accent-500/10 border border-accent-500/20 p-8 md:p-10 text-center">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3">
                  无需注册，立即畅享免费电影
                </h2>
                <p className="text-sm text-foreground-500 max-w-[600px] mx-auto mb-6">
                  海量高清免费电影资源每日更新，涵盖全类型影片，随时随地开启您的观影之旅
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href="/category/all"
                    className="px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    开始免费观影
                  </a>
                  <a
                    href="/about"
                    className="px-8 py-3 rounded-full bg-background-200/70 text-foreground-700 font-medium text-sm hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer border border-background-300/50"
                  >
                    了解更多
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}